






import Vue from 'vue';
export default Vue.extend({
  name: 'ActionButton',
  props: {
    buttonTitle: {
      type: String,
      required: true,
    },
    onClick: {
      type: Function,
      required: true,
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/ActionButton.vue